import { createTheme, ThemeProvider } from '@mui/material/styles'
import "./styles/App.scss";
import AppRouter from "./routers/AppRouter";
import Theme from "./Theme";
import { checkSOData } from "./utils/accountUtils";
import ToastProvider from "./context/ToastContext";
import { esES as coreEsES } from '@mui/material/locale'
import {esES} from "@asf-libs/x-data-grid-premium";
const theme = createTheme({palette: {
    primary: {
      main: '#008F39',
    },
    secondary: {
      main: '#BDBBB0',
    },
    error: {
      main: '#B00020',
    },
  },}, esES, coreEsES)
export const App = () => {

  checkSOData()
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <AppRouter />
      </ToastProvider>
    </ThemeProvider>
  )
}

export default App;
